import { auth, err } from '../utils';
import axios, { AxiosResponse } from 'axios';
import * as Entity from '../utils/types/Entity';
import { CurrencyUnit } from '../utils/types/Currency/Currency.types';

const URL = '/api/claim';

type EligibilityResponse = {
  eligibilityMap: Record<Entity.PayoutProvider, boolean>;
};

const approveClaims = async (
  token: string,
  claims: { id: string }[],
  payoutAccountID: string,
): Promise<void> => {
  try {
    const res: AxiosResponse<void> = await axios.patch(
      `${URL}/approve`,
      {
        claims,
        payoutAccountID,
      },
      {
        headers: auth.bearerAuthHeader(token),
      },
    );

    if (res.status < 200 || res.status >= 300) {
      throw new Error(`${res.status} error`);
    }

    return;
  } catch (e) {
    throw err.handleError(e, 'error approving claims');
  }
};

const acceptClaimsTerms = async (
  token: string,
  ids: string[],
): Promise<void> => {
  try {
    const res: AxiosResponse<Record<string, unknown>> = await axios.post(
      `${URL}/acknowledgements`,
      { ids },
      {
        headers: auth.bearerAuthHeader(token),
      },
    );

    if (res.status < 200 || res.status >= 300) {
      throw new Error(`${res.status} error`);
    }

    return;
  } catch (e) {
    throw err.handleError(e, 'error accepting claim terms');
  }
};

const verifyProviderEligibilityForClaim = async (
  token: string,
  ids: string[],
  currency: CurrencyUnit,
): Promise<Record<Entity.PayoutProvider, boolean>> => {
  try {
    const res: AxiosResponse<EligibilityResponse> = await axios.get(
      '/api/claim/eligibility',
      {
        params: {
          ids,
          currency,
        },
        paramsSerializer: {
          indexes: null,
        },
        headers: auth.bearerAuthHeader(token),
      },
    );

    if (res.status < 200 || res.status >= 300) {
      throw new Error(`${res.status} error`);
    }
    return res.data.eligibilityMap;
  } catch (e) {
    throw err.handleError(e, 'error verifying provider eligibility');
  }
};

export default {
  approveClaims,
  acceptClaimsTerms,
  verifyProviderEligibilityForClaim,
};
